
import { Component, Prop } from 'vue-property-decorator';
import Listing from 'ah-common-lib/src/common/components/listing/Listing.vue';
import { PaginatedQuery, IndividualGroup } from 'ah-api-gateways';
import { groupTableFieldsFull } from '@/app/components/groups/tableFields/groupTableFields';
import { useAuthStore } from '@/app/store/authModule';

@Component
export default class GroupListing extends Listing<IndividualGroup> {
  @Prop({ default: () => ({ tableFields: groupTableFieldsFull }) }) config!: { tableFields: [] };

  protected loadDataRequest(query: PaginatedQuery) {
    return this.groupService.listGroups(query, this.groupParentId);
  }

  get authStore() {
    return useAuthStore();
  }

  get groupService() {
    if (this.authStore.isClientUser) {
      return this.$services.clientGroup;
    } else {
      return this.$services.partnerGroup;
    }
  }

  get groupParentId() {
    if (this.authStore.isClientUser) {
      return this.authStore.loggedInIdentity!.client!.id;
    } else {
      // Partner group endpoints do not use id in path, when called from a partner user
      return undefined;
    }
  }
}
